import React, { Component } from "react";
import { Navigate  } from 'react-router-dom';
import axios from 'axios'; 

import Serverurl from './Apiurl';
import Button from '@mui/material/Button';
import Collapse from '@mui/material/Collapse';
import CloseIcon from '@mui/icons-material/Close';
import Alert from '@mui/material/Alert';
import IconButton from '@mui/material/IconButton';
//import { DropzoneArea } from 'material-ui-dropzone';
//import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import CheckRoundedIcon from '@mui/icons-material/CheckRounded';
import { FileUploader } from "react-drag-drop-files";
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody'; 
import TableCell from '@mui/material/TableCell';  
import TableRow from '@mui/material/TableRow';
import TableHead from '@mui/material/TableHead';  

export default class Journalimport extends Component {
	
	constructor(props) 
	  {super();
		 this.state = {ExportData:[],redirect:false,pagename:'',errormessage:'',open:false,imgfile:'',primarybtntext:'Import'}
	  }

 componentDidMount()
	{
		document.title = "Isifol - Stock Import";
		if(localStorage.getItem("ISIuserid")==null)
		  {

		   this.setState({
            logredirect: true,
			pagename:'/Login'
          })
		  }	
this.apicallforexport();	 
	}
	
apicallforexport(){
	

	 axios.post(localStorage.getItem("ISIurl")+'ajaxjournal.php?action=journalexport')
     
	
  .then(resp => {  		
    if(resp.data.length>0){

			this.setState({ 		   
			  ExportData:resp.data,  			   
			   });
		
			     }
	 else{
		   this.setState({ExportData:[],});
	 }
 
    });
}	
	handleErrorclose=(event)=>{
	  
	this.setState({open: false});  
  }
  OnImportSubmit=(event)=>{
	   event.preventDefault(); 
	   var selectedFile = this.state.imgfile;
	   if (!selectedFile || selectedFile === "") {
    this.setState({
      errormessage: "Please upload a CSV file.",
      open: true
    });
    window.scrollTo({ top: 0 });
    return false;
  }

var validTypes = ["text/csv", "application/vnd.ms-excel"];
  if (validTypes.indexOf(selectedFile.type) === -1) {
    this.setState({
      errormessage: "Invalid file type. Only CSV files are allowed.",
      open: true
    });
    window.scrollTo({ top: 0 });
    return false;
  }
	  if( this.state.imgfile[0]==="")
	  {
   this.setState({ errormessage:"Upload file.", open: true });
    window.scrollTo({ top: 0 });
    return false;
	  }		  
	   var formData = new FormData();
	 formData.append('action','journalimport')
		   formData.append('Filedata',selectedFile)		   
	formData.append('userid',localStorage.getItem("ISIuserid"))
	this.setState({primarybtntext:'Processing...'});
	axios.post(localStorage.getItem("ISIurl")+"ajaxjournal.php", formData, {
	}).then(res => {
		
		this.setState({primarybtntext:'Import',open:true,errormessage:'Uploaded successfully'});
		
	});
  }
 handleFilesChange = (file) => {
  this.setState({ imgfile: file });
};
	render() {
		
if (this.state.redirect === true) {
      return <Navigate to={this.state.pagename} />
    }
	const maxJournals = Math.max(
  ...this.state.ExportData.map(order => (order.journals ? order.journals.length : 0))
);
	const fileTypes = ["CSV"];
	 return (
  
	 <React.Fragment> 
	  <div className="pagebox-col">
	 <div className="">
			<div className="boxheading">
				  <div className="contntpad">
					 <p>  <Collapse in={this.state.open}>
										<Alert
										  action={
											<IconButton
											  aria-label="close"
											  color="inherit"
											  size="small"
											  onClick={() => {
											   this.handleErrorclose();
											  }}
											>
											  <CloseIcon fontSize="inherit" />
											</IconButton>
										  } severity="error"
										>
										{this.state.errormessage}
										</Alert>
								</Collapse></p>
				  <h2> Import Journal</h2>
				  </div> </div>
	   <div className="contntpad ">
	    <div className="formviewatt ">
	   <p className="fileuploaddrop">
<FileUploader
  multiple={false}
  handleChange={this.handleFilesChange}
  name="file"
  types={fileTypes}
>
  <div style={{ padding: '20px', border: '2px dashed #ccc', borderRadius: '6px', textAlign: 'center' }}>
    <p>Drag & drop your CSV file here, or click to browse.</p>
  </div>
</FileUploader>
</p>
<p>
  {this.state.imgfile
    ? "File name: " + this.state.imgfile.name
    : "No files uploaded yet."}
</p>
	

	{/* <p className="fileuploaddrop">
	  <FileUpload
                    multiFile={false}
                    onFilesChange={this.handleFilesChange}
                    onContextReady={(context) => {}}
                  />
	  <DropzoneArea dropzoneText="" 
 showPreviews={true}
  showPreviewsInDropzone={false}
  useChipsForPreview
  previewGridProps={{container: { spacing: 1, direction: 'row' }}}
dropzoneText={"Drag and drop/Select CSV file here"}
  previewText="Uploaded files"
maxFileSize={5000000} Icon={CloudUploadIcon} dropzoneClass="filesupld" filesLimit={1} acceptedFiles={['text/csv']} 
 
 
  onChange={(files) => {
  var file, img;
  var _URL = window.URL || window.webkitURL;
  this.setState({ imgfile: files })
  
		
 

	 }}
  
 
/> 
</p>*/} <p className="alignright"><Button variant="standard" className="frmSecondarybtn"  onClick={this.OnImportSubmit}>
								  {this.state.primarybtntext}
						</Button> &nbsp; <ReactHTMLTableToExcel
                    id="test-table-xls-button"
                    className="exportbtn"
                    table="journal"
                    filename="Journal"
                    sheet="Journal"
                    buttonText="EXPORT"
					variant="contained"/></p>
	   <div className="clear"></div>
	   </div>  </div>
	   </div>
	   </div>
<Table id="journal" style={{ display: 'none' }}>
  <TableHead>
    <TableRow>
      <TableCell>Reference</TableCell>
      <TableCell>Date</TableCell>
      <TableCell>Description</TableCell>

     
      {Array.from({ length: maxJournals }).map((_, i) => (
        <React.Fragment key={i}>
          <TableCell>Ledger Account Number</TableCell>
          <TableCell>Details</TableCell>
          <TableCell>Debit</TableCell>
          <TableCell>Credit</TableCell>
        </React.Fragment>
      ))}
    </TableRow>
  </TableHead>

  <TableBody>
    {this.state.ExportData.map((order, index) => {
      const journals = order.journals || [];
      return (
        <TableRow key={index}>
          <TableCell>{order.jo_reference}</TableCell>
          <TableCell>{order.journaldate}</TableCell>
          <TableCell>{order.jo_description}</TableCell>

          {/* Render journal cells for this order */}
          {Array.from({ length: maxJournals }).map((_, i) => {
            const item = journals[i];
            const fields = ['le_code', 'jr_details', 'jr_debit', 'jr_credit'];
            return fields.map(field => (
              <TableCell key={i + '-' + field} style={{ border: '1px solid #e0e0e0' }}>
                {item ? item[field] : ''}
              </TableCell>
            ));
          })}
        </TableRow>
      );
    })}
  </TableBody>
</Table>	  

	  

	   {/*<Table id="journal" style={{ display: 'none' }}>
  <TableHead>
    <TableRow>
      <TableCell>Reference</TableCell>
      <TableCell>Date</TableCell>
      <TableCell>Description</TableCell>
      <TableCell>Ledger Account Number</TableCell>
      <TableCell>Details</TableCell>
      <TableCell>Debit</TableCell>
      <TableCell>Credit</TableCell>
      
    </TableRow>
  </TableHead>
  <TableBody>
    {this.state.ExportData.map((order, index) => (
      <React.Fragment key={index}>
        <TableRow>
          <TableCell>{order.jo_reference}</TableCell>
          <TableCell>{order.journaldate}</TableCell>
          <TableCell>{order.jo_description}</TableCell>
           <TableCell></TableCell>
          <TableCell></TableCell>
          <TableCell></TableCell>
          <TableCell></TableCell>
        </TableRow>

        {order.journals?.length > 0 && order.journals.map((item, pindex) => (
          <TableRow key={pindex}>
            <TableCell></TableCell>
			 <TableCell></TableCell>
			 <TableCell></TableCell>
            <TableCell style={{ border: '1px solid #e0e0e0' }}>{item.le_code}</TableCell>
            <TableCell style={{ border: '1px solid #e0e0e0' }}>{item.jr_details}</TableCell>
            <TableCell style={{ border: '1px solid #e0e0e0' }}>{item.jr_debit}</TableCell>
			 <TableCell style={{ border: '1px solid #e0e0e0' }}>{item.jr_credit}</TableCell>
          </TableRow>
        ))}
      </React.Fragment>
    ))}
  </TableBody>
	   </Table>*/}
	   
	 </React.Fragment> 
	 )
	}
}








